// import useSchoolyears from 'queries/schoolyears/useSchoolyears';

// Uncomment when ready to communicate
export function useHasAccessToFDPTemplates() {
  // const { data: schoolyears } = useSchoolyears(false, true);
  return import.meta.env.VITE_ENVIRONMENT !== 'production';
  // return schoolyears?.some(sy =>
  //   (sy?.schools || []).some(s =>
  //     (s?.classrooms || []).some(cl => (cl?.cycle || []).includes('Cycle 1')),
  //   ),
  // );
}
